module.exports = __webpack_public_path__ + "img/doughnut-chart-default.e599af32.svg";